<template>
  <div class="services">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-heading">
            <h2>Telecoms Media & <em>Technology</em></h2>
            <span>Telecoms Media & Technology: Connecting, entertaining, and innovating the digital world.</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="service-item">
            <img src="../assets/service_01.jpg" alt="" />
            <div class="down-content">
              <h4>Telecoms & ICT sales</h4>
              <p>
                Telecoms & ICT sales involve selling communication and technology solutions, such as phones, network equipment, and software. Sales professionals focus on meeting client needs and driving growth through strategic solutions.
              </p>
              <router-link to="/services" class="filled-button">Read More</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="service-item">
            <img src="../assets/service_02.jpg" alt="" />
            <div class="down-content">
              <h4>Fixed Network FTTH design</h4>
              <p>
                Fixed Network FTTH design involves planning high-speed fiber optic networks that extend directly to homes. It focuses on maximizing efficiency and ensuring reliable, high-bandwidth connections. This design supports fast internet and service delivery.
              </p>
              <router-link to="/services" class="filled-button">Read More</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="service-item">
            <img src="../assets/service_03.jpg" alt="" />
            <div class="down-content">
              <h4>Satellite Solutions Broadcast</h4>
              <p>
                Satellite Solutions for Broadcast & Digital Media provide reliable, high-quality transmission of TV, radio, and online content via satellite. They enable global content distribution, offering broad reach and seamless integration for media and broadcasting needs.              </p>
              <router-link to="/services" class="filled-button">Read More</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ServicesCard",
};
</script>
<style scoped>
.down-content p {
  text-align: justify;
}
.service-item img {
  height: 275px;
}
</style>